module.exports = __webpack_public_path__ + "img/wavy.a42dddbb.svg";